<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getCookie, setCookie } from '@/utils/mycookie';
import { randomString, jumpTo, saveData } from '@/utils/myutils';
import { hex_md5 } from '@/utils/md5';
import { infoUser } from '@/api';
// 初始化设备唯一识别码
if (getCookie('x-myweb-key') == null) {
  //设置设备唯一识别码
  setCookie('x-myweb-key', hex_md5(new Date().valueOf().toString() + randomString(50)));

}
export default {
  name: 'App',
  data() {
    return {
    }
  },
  mounted() {
    this.initTheme();
    if (this.userInfo != null) {
      if (this.userInfo?.user?.member == -1) {
        jumpTo(this, "个人信息", {}, {});
      }
      this.userInfoFuc();
    }
  },
  methods: {
    async userInfoFuc() {

      const data = await infoUser();

      if (data.code == 200) {

        saveData("user-inf", JSON.stringify(data));
        // 刷新仓库数据
        this.$store.dispatch('login');

      } else {

        switch (data.code) {

          case 409:

          case 401:

            this.$store.dispatch('logout');

            window.location.reload();

            break;

        }

        this.$message.error(data.message);

      }

    },
    initTheme() {
      // 初始化加载保存的主题
      const savedTheme = localStorage.getItem('theme') || 'light';
      document.documentElement.setAttribute('data-theme', savedTheme);
    },

  },
  components: {
  },
  computed: {
    ...mapState(['userInfo'])
  },
  // 动态设置页面标题、关键字和描述等属性  
  metaInfo() {
    return {
      title: this.$route.meta.metaInfo.title,
      meta: [
        { name: "keywords", content: this.$route.meta.metaInfo.keywords },
        { name: "description", content: this.$route.meta.metaInfo.description },
      ]
    }
  }
}
</script>

<style>
#app {
  height: 100%;
  width: 100%;
  position: relative;
  padding: 0;
  margin: 0;
  background: #EBEBEB;
  background: var(--bg-color);
  box-sizing: border-box;
  overflow: hidden;
}
</style>
